import {Card, Select, Tabs, Typography} from "antd";
import {DataGridProvider} from "../Components/data-grid/DataGridContext";
import AdminCheckHistory from "../Components/AdminDashboard/CheckHistoryGrid/AdminCheckHistory";
import AdminCompareHistory from "../Components/AdminDashboard/CompareHistoryGrid/AdminCompareHistory";
import AdminUserDashboardGrid from "../Components/AdminDashboard/UserGrid/AdminUserDashboardGrid";
import {useEffect, useState} from "react";
import ApiService from "../Service/ApiService";
import AdminUserGrid from "../Components/AdminDashboard/UserGrid/AdminUserGrid";

export default function AdminDashboard() {
    const [users, setUsers] = useState([])
    const [userId, setUserId] = useState(null)

    const getUsers = async () => {
        const res = await ApiService.AdminDashboard.GetUserList();
        if(res) {
            setUsers(res.data)
        }
    }

    useEffect(() => {
        getUsers()
    }, [])

    return (
        <>
            <Card title={'Admin Dashboard'}>
                <Typography.Text>
                    Users:
                </Typography.Text>
                <Select
                    placeholder={'Select User'}
                    style={{width: 300, marginLeft: 8, marginBottom: 16}}
                    options={users}
                    onSelect={(value, option) => {
                        setUserId(value)
                    }}
                    filterOption={(inputValue, option) => {
                        return option.email.includes(inputValue.toLocaleLowerCase())
                    }}
                    showSearch={true}
                    onClear={() => {setUserId(null)}}
                    allowClear={true}
                    fieldNames={{
                        label: 'email',
                        value: 'id'
                    }}
                />
                <Tabs>
                    <Tabs.TabPane tab={'Registered Users'} key={'Registered Users'}>
                        <DataGridProvider>
                            <AdminUserGrid userId={userId}/>
                        </DataGridProvider>
                    </Tabs.TabPane>
                    <Tabs.TabPane tab={'User Dashboard'} key={'Users'}>
                        <DataGridProvider>
                            <AdminUserDashboardGrid userId={userId}/>
                        </DataGridProvider>
                    </Tabs.TabPane>
                    <Tabs.TabPane tab={'Checks'} key={'Checks'}>
                        <DataGridProvider>
                            <AdminCheckHistory userId={userId} />
                        </DataGridProvider>
                    </Tabs.TabPane>
                    <Tabs.TabPane tab={'Comparisons'} key={'Comparisons'}>
                        <DataGridProvider>
                            <AdminCompareHistory userId={userId} />
                        </DataGridProvider>
                    </Tabs.TabPane>
                    {/*<Tabs.TabPane tab={'Compare History'} key={'Compare History'}>*/}
                    {/*    <DataGridProvider>*/}
                    {/*        <CompareHistory />*/}
                    {/*    </DataGridProvider>*/}
                    {/*</Tabs.TabPane>*/}
                </Tabs>
            </Card>
        </>
    )
}